import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '../context/AuthContext';
import ProtectedRoute from '../components/ProtectedRoute';
import AdminLayout from '../layouts/AdminLayout';
import { PERMISSIONS } from '../utils/permissions';

// Pages
import LoginPage from '../pages/LoginPage';
import AuthCallbackPage from '../pages/AuthCallbackPage';
import DashboardPage from '../pages/Admin/DashboardPage';
import UserManagementPage from '../pages/Admin/UserManagementPage';
import LockerManagementPage from '../pages/Admin/LockerManagementPage';
import RoleManagementPage from '../pages/Admin/RoleManagementPage';
import AuditLogPage from '../pages/Admin/AuditLogPage';

const AppRoutes: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          
          {/* Admin Routes - Permission-based access (Super Admin, Campus Admin, Training Officer) */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <DashboardPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/users"
            element={
              <ProtectedRoute 
                requiredPermissions={[PERMISSIONS.USERS_READ]}
              >
                <AdminLayout>
                  <UserManagementPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/lockers"
            element={
              <ProtectedRoute 
                requiredPermissions={[PERMISSIONS.LOCKERS_READ]}
              >
                <AdminLayout>
                  <LockerManagementPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/roles"
            element={
              <ProtectedRoute 
                requiredPermissions={[PERMISSIONS.ROLES_READ]}
              >
                <AdminLayout>
                  <RoleManagementPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/audit-logs"
            element={
              <ProtectedRoute 
                requiredPermissions={[PERMISSIONS.LOGS_READ]}
              >
                <AdminLayout>
                  <AuditLogPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/rooms"
            element={
              <ProtectedRoute 
                requiredPermissions={[PERMISSIONS.ROOMS_READ]}
              >
                <AdminLayout>
                  <div className="text-center py-12">
                    <h2 className="text-2xl font-bold text-gray-900">Quản lý Phòng học</h2>
                    <p className="mt-2 text-gray-600">Trang này đang được phát triển</p>
                  </div>
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/schedules"
            element={
              <ProtectedRoute 
                requiredPermissions={[PERMISSIONS.SCHEDULES_READ]}
              >
                <AdminLayout>
                  <div className="text-center py-12">
                    <h2 className="text-2xl font-bold text-gray-900">Lịch học</h2>
                    <p className="mt-2 text-gray-600">Trang này đang được phát triển</p>
                  </div>
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/bookings"
            element={
              <ProtectedRoute 
                requiredPermissions={[PERMISSIONS.BOOKINGS_READ]}
              >
                <AdminLayout>
                  <div className="text-center py-12">
                    <h2 className="text-2xl font-bold text-gray-900">Đặt phòng</h2>
                    <p className="mt-2 text-gray-600">Trang này đang được phát triển</p>
                  </div>
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/settings"
            element={
              <ProtectedRoute 
                requiredPermissions={[PERMISSIONS.SETTINGS_UPDATE]}
              >
                <AdminLayout>
                  <div className="text-center py-12">
                    <h2 className="text-2xl font-bold text-gray-900">Cài đặt</h2>
                    <p className="mt-2 text-gray-600">Trang này đang được phát triển</p>
                  </div>
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AppRoutes;

